const initialState = {
  startDate: "",
  industryName: "",
  companyName: "",
  mission: "",
  vision: "",
  companyOverview: "",
  companyEstablishmentDate: "",
  goals: []
};

export default initialState;
